class SuccessController{
    constructor(_, preFetchedData) {
        this._ = _;
        this.preFetchedData = preFetchedData;
        this.successMessage = null;
        this.pathToDisclosure = null;
    }

    $onInit() {

        if (this.preFetchedData.disclosureData.type === "Conflict") {
            this.successMessage = `Your Conflict of Interest has been successfully submitted`;
            this.pathToDisclosure = `/coi/disclose/conflictofinterest/review/${this.preFetchedData.disclosureData.id}`;
        } else {
            this.successMessage = `Your Gift disclosure has been successfully submitted`;
            this.pathToDisclosure = `/coi/disclose/gift/review/${this.preFetchedData.disclosureData.id}`;
        }

    }
}

SuccessController.$inject = ['_', 'preFetchedData'];

export default SuccessController;


// WEBPACK FOOTER //
// ./app/disclose/success.controller.js